/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useMemo } from 'react'
import { UserDepositBonusModelUtils } from 'mvppoker-portal-common/model/UserDepositBonusModelUtils'
import { WalletButton } from './Wallet/WalletButton'
import { ProfileButton } from './Profile/ProfileButton'
import { R } from '../../R/R'
import { useActiveUser } from '../../state/hooks/ActiveUserHooks'
import { useWindowSize } from '../../utils/useWindowSize'
import { updateService } from '../../logic/UpdateService'
import { useAvailableRooms } from '../../state/hooks/roomsHooks'
import { FriendsButton } from './Friends/FriendsButton'
import { useDepositBonus, useHasUnreadChat } from '../../state/hooks/ProfileDataHooks'
import ChatMessageToast from './ChatMessage/ChatMessageToast'
import './AppBar.scss'

const REFRESH_RATE = 5_000

export default () =>
{
	const user = useActiveUser()
	const rooms = useAvailableRooms()
	const depositBonus = useDepositBonus()
	const hasUnreadChat = useHasUnreadChat()

	useWindowSize('width')

	useEffect(() => {
		updateService.refreshOtherProfiles()
		
		const task = () => {
			updateService.refreshUser()
			updateService.refreshRooms()
			updateService.refreshWallet()
			updateService.refreshDepositBonus()
		}

		task()
		const id = setInterval(task, REFRESH_RATE)

		return () => {
			clearInterval(id)
		}
	}, [])

	const name = useMemo(() => {
		return user?.user?.info.name ?? ''
	}, [user])

	const walletAmount = useMemo(() => {
		return user?.wallet.amount ?? '-'
	}, [user])

	const friends = useMemo(() => {
		return user?.user.friends
	}, [user])

	const pastUserGame = useMemo(() => {
		if (user?.user){
			return rooms.find((game) => game.players.find((p) => p.profile.userId === user?.user.id) !== undefined)
		}
	}, [rooms, user])

	const pastUserPlayer =  pastUserGame?.players.find((p) => p.profile.userId === user?.user.id)
	const pastGameIndicator = useMemo(() => {

		if (pastUserPlayer){
			const status = pastUserPlayer.isLeaving ? 'LEAVING' : pastUserPlayer.status
			const money = pastUserPlayer.moneyAmount
			return <div id='pastuserinfo' >
					CURRENTLY {status}
					<br/>
					STILL ${money} IN GAME
			</div>
		}
	}, [pastUserPlayer])

	const showDepositBonusIndicator = depositBonus && UserDepositBonusModelUtils.ShouldShowIndicator(depositBonus)
	const showWalletIndicator = showDepositBonusIndicator === true

	return (
		<div id='app-bar'>
			<div id='app-bar-l' />
			<img id='app-bar-logo' src={R.images.logoMvp} alt='mvp logo' />
			<div id='app-bar-r'>
				{pastGameIndicator}
				<WalletButton moneyAmount={walletAmount} showIndicator={showWalletIndicator} />
				<FriendsButton showFriendsIndicator={hasUnreadChat} showFriendsRequetsIndicator={(friends?.requestsReceived.length ?? 0) > 0} />
				<ProfileButton name={name} />
			</div>
			<ChatMessageToast />
		</div>
	)
}
